import { HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { CwtDictionaryPipeModule } from '@cawita/core-front';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { IsoDatePipe } from './iso-date.pipe';
import { CwtLanguageConfig, CWT_LANGUAGE_CONFIG } from './language.config';
import { MergedHttpLoader } from './language.loader';
import { CwtLanguageService } from './language.service';
import { LocaleDatePipe } from './locale-date.pipe';

export function initializeLanguageFactory(initService: CwtLanguageService) {
    return async () => { await initService.init().toPromise(); }
}

export function provideTranslateLoader(config: CwtLanguageConfig) {
    return {
        provide: TranslateLoader,
        deps: [HttpClient],
        useFactory: translateLoaderFactory(config.appName, config.translationFilePath)
    };
}

export function translateLoaderFactory(appName: string, path: string) {
    return (httpClient: HttpClient) => new MergedHttpLoader(
        new TranslateHttpLoader(httpClient, `${path}/common/`, `.json`),
        new TranslateHttpLoader(httpClient, `${path}/${appName}/`, `.json`)
    );
}

@NgModule({
    imports: [
        HttpClientModule,
        TranslateModule,
    ],
    exports: [
        HttpClientModule,
        TranslateModule,
        LocaleDatePipe,
        IsoDatePipe,
    ],
    declarations: [
        LocaleDatePipe,
        IsoDatePipe
    ],
    providers: [],
})
export class CwtLanguageModule {
    static forRoot(config: CwtLanguageConfig): ModuleWithProviders<CwtLanguageModule> {
        return {
            ngModule: CwtLanguageModule,
            providers: [
                CwtLanguageService,
                ...CwtDictionaryPipeModule.forRoot().providers,
                ...TranslateModule.forRoot({ useDefaultLang: true, loader: provideTranslateLoader(config) }).providers,
                { provide: CWT_LANGUAGE_CONFIG, useValue: config },
                { provide: APP_INITIALIZER, deps: [CwtLanguageService], useFactory: initializeLanguageFactory, multi: true },
            ]
        }
    }
}
